import { render, staticRenderFns } from "./Vault.vue?vue&type=template&id=65de5e39&scoped=true&"
import script from "./Vault.vue?vue&type=script&lang=ts&"
export * from "./Vault.vue?vue&type=script&lang=ts&"
import style0 from "../styles/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./Vault.vue?vue&type=style&index=1&id=65de5e39&prod&lang=css&"
import style2 from "./Vault.vue?vue&type=style&index=2&id=65de5e39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65de5e39",
  null
  
)

export default component.exports